// BCFLoader (§4). soubor → detekce verze → rozbalení → validace → XML → viewpoints
// → snapshots → normalizace → interní BCF model. Podporuje .bcf i .bcfzip.
import { zipRead } from "./zip.js";
import { parseXML, attr } from "./xml.js";
import { BCF21Parser } from "./BCF21Parser.js";
import { BCF30Parser } from "./BCF30Parser.js";
import { createProject } from "../core/model.js";

const td = new TextDecoder();

function detectVersion(files) {
  const v = files.get("bcf.version");
  if (v) {
    try {
      const doc = parseXML(td.decode(v));
      const id = attr(doc.documentElement, "VersionId") || (doc.documentElement.getElementsByTagName("DetailedVersion")[0] || {}).textContent;
      if (id && /3\./.test(id)) return "3.0";
      if (id && /2\.1/.test(id)) return "2.1";
    } catch (_) {}
  }
  // Heuristika: 3.0 dává Comments/Viewpoints dovnitř Topicu; 2.1 jako sourozence.
  return "2.1";
}

export class BCFLoader {
  async loadBCFBuffer(buffer) {
    const files = await zipRead(buffer);
    const version = detectVersion(files);
    const parser = version === "3.0" ? new BCF30Parser() : new BCF21Parser();
    const topics = parser.parse(files);
    const project = createProject({ name: "Importovaný BCF" });
    // Project metadata (project.bcfp) — volitelné.
    const bcfp = files.get("project.bcfp");
    if (bcfp) { try { const d = parseXML(td.decode(bcfp)); const pe = d.getElementsByTagName("Project")[0]; if (pe) { project.projectId = attr(pe, "ProjectId") || project.projectId; const nm = pe.getElementsByTagName("Name")[0]; if (nm) project.name = nm.textContent.trim(); } } catch (_) {}
    }
    project.topics = topics;
    return { project, version, topicCount: topics.length };
  }

  async loadBCFZip(file) { return this.loadBCFBuffer(await file.arrayBuffer()); }
  async loadBCF(file) { return this.loadBCFBuffer(await file.arrayBuffer()); }
}
